exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.system-notification[data-v-5b83e2a0]{\n\tright: 50px;\n\tbottom: 10px;\n\n\tmax-width: 440px;\n\tmin-width: 440px;\n\tposition: fixed;\n}\n.notification-item[data-v-5b83e2a0]{\n\tbackground: #fff;\n\tpadding: 30px;\n\t\t\tmargin-bottom: 15px;\n}\n\n", ""]);

// exports
